import { injectIntl } from "react-intl";
import React from "react";
import apiService from "src/services/api.service";

const DeleteStrategy = (props) => {

    const deleteStrategy = () => {
        apiService.deleteStrategy(props.strategy?._id).then(() => {
            props.close()
        })
    }

    return (
        <div className="NewStrategyModalOverlay">
            <div className="DeleteStrategyModal">
                <div className={ "w-full flex justify-between" }>
                    <div className={ "DeleteStrategy" }>
                        <img alt={ "Logo" } src={ "/media/icons/deleteIcon.svg" } className={ "w-[18px] h-[18px]" }/>
                        Are You Sure You Want to Delete This Strategy?
                    </div>
                    <button className={ "CloseIconButton" } onClick={ props.close }>
                        <img alt={ "Logo" } src={ "/media/icons/closeIcon.svg" } className={ "w-5 h-5" }/>
                    </button>
                </div>
                <div className={ "flex flex-col gap-4 w-full" }>
                    <div className={ "HorizontalDivider" }></div>
                    <div className={ "StrategyDeleteWarning" }>This action cannot be undone. You are about to delete the
                        strategy named '
                        <span className={ "StrategyDeleteWarningName" }>{props.strategy?.name}</span>'. Do you wish to proceed?
                    </div>
                    <div className={ "HorizontalDivider" }></div>
                </div>
                <div className={ "modal-actions" }>
                    <button className={ "CloseButton" } onClick={ props.close }>Cancel</button>
                    <button className={ "DeleteButton" } onClick={ deleteStrategy }>Delete</button>
                </div>
            </div>
        </div>
    );
}

export default injectIntl(DeleteStrategy);
